module.exports = __webpack_public_path__ + "static/media/parceiro-ciet.fe46a929.jp2";